import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

// Ends Add product on web (routines/products/new_product/_finish.html.erb):
// closes the drawer around it, which runs the routine's redrawn sections
// (drawer-close-streams), then sets the drawer's frame back to the search so
// it opens there next time. Outside a drawer the routine page loads instead.
export default class extends Controller {
  static targets = [ "skeleton" ]
  static values = { searchPath: String, fallbackPath: String }

  connect() {
    const drawer = this.element.closest(".bottom-drawer")
    if (!drawer?.hideSheet) return Turbo.visit(this.fallbackPathValue)

    const frame = this.element.closest("turbo-frame")
    const skeleton = this.skeletonTarget.innerHTML

    drawer.addEventListener("close", () => {
      if (!frame) return

      const searchUrl = new URL(this.searchPathValue, window.location.href).href
      frame.innerHTML = skeleton
      if (frame.src === searchUrl) {
        frame.reload()
      } else {
        frame.src = searchUrl
      }
    }, { once: true })

    drawer.hideSheet()
  }
}
